<template>
<!-- <page
  title='Operating Hours'
  :with-add='false'
  :with-refrehs='true'
  :crumbs='crumbs'
  :loading='request.loading'
  class='grey lighten-4'
  @refresh='get' > -->
  <!-- <pre v-text='filteredHours' /> -->
  <div>
    <request-status :request="request" />
    <template v-if='!globalInitLoading && meId' >
      <v-card outlined class='ma-3 mt-4'
        v-for='(hour, index) in filteredHours' :key='hour.id' >
          <!-- <pre v-text='practitioner' /> -->
          <v-card-title>
            {{ getSpaceName(hour.space) }}.
            <v-chip small outlined label class='ml-3' >
              <v-icon small left >mdi-map-marker-circle</v-icon>
              {{ getAddressName(hour) }}
            </v-chip>
          </v-card-title>
          <hours-view
            v-if="getPractitioner(hour)"
            v-model='hours[index]'
            :space-id='hour.space'
            :location="getLocation(hour)"
            :practitioner="getPractitioner(hour)"
            @refresh='get' />
      </v-card>
    </template>
  </div>
<!-- </page> -->
</template>
<script>
// import Page from '@/components/layouts/Page'
import OperationHoursListItem from '@/components/listitems/OperationHoursListItem.vue'
import HoursView from '@/views/space/operationhours/HoursView.vue'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'OperatingHours',
  components: {HoursView},
  props: {
    touch: { type: Number, default: 0 },
    spaceId: { required: false }
  },
  data () {
    return {
      edithoursdialog: false,
      request: {
        resource: 'ag.practitioner.hours',
        params: {
          ordering: 'space'
        }
      },
      attrs: {
        withEdit: true
      },
      activeHours: {},
      li: OperationHoursListItem
    }
  },
  computed: {
    ...mapGetters('identity', ['me', 'meId', 'getPractitionerById', 'getSpaceById', 'getLocationBySpaceAndId']),
    hours () {
      return this.getObjectPath(this.request, 'result.results', [])
    },
    filteredHours () {
      return this.hours.filter((hr) => {
        if (hr.space && hr.addresses && hr.addresses.length > 0) {
          if (this.spaceId && hr.space !== this.spaceId) { return false }
          return true
        }
        return false
      })
    },
    crumbs () {
      return [
        {text: 'Home', to: '/'},
        {text: 'Profile', to: '/settings/me', 'exact': true },
        {text: 'Operation hours', to: '/settings/me/hours', 'exact': true }
      ]
    }
  },
  mounted () {
    this.request.params.practitioner = this.meId
    this.get()
  },
  watch: {
    touch () { this.get() },
    meId () {
      if (this.meId) {
        this.request.params.practitioner = this.meId
        this.get()
      }
    }
  },
  methods: {
    get () {
      this.$request('get', this.request)
    },
    edit (hrs) {
      if (hrs.addresses && hrs.addresses.length > 0) {
        let location = JSON.parse(JSON.stringify(this.getLocationBySpaceAndId(hrs.space, hrs.addresses[0])))
        // let space = this.getSpaceById(hrs.space)
        hrs.practitioner = this.meId
        location.operation_hours = [hrs]
        console.log(location)
        Vue.set(this.activeHours, 'space', hrs.space)
        Vue.set(this.activeHours, 'location', location)

        this.edithoursdialog = true
      }
    },
    getPractitioner (hours) {
      return this.getPractitionerById(hours.practitioner_id)
    },
    getLocation (hours) {
      if (hours) {
        return this.getLocationBySpaceAndId(hours.space, hours.addresses[0])
      }
      return null
    },
    getSpaceName (spaceId) {
      let s = this.getSpaceById(spaceId)
      if (s) {
        return s.title
      }
      return spaceId
    },
    getAddressName (hours) {
      let loc = this.getLocation(hours)
      if (loc) {
        return loc.name || loc.address
      }
      return ''
    }
  }
}
</script>
